import { createContext } from 'react';

export default createContext({
  loading: false,
  restaurant: null,
  setRestaurant: () => {},
  createRestaurant: () => {},
  updateRestaurant: () => {},
});
